import React from 'react';
import styled from 'styled-components';
import { Section } from 'components/layout/Section';
// import { Form } from 'modules/footer/components/Form';
import { Header } from 'components/header';
import { BodyText } from 'components/typography/bodyText';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useStaticQuery, graphql } from 'gatsby';
import media from 'constants/styles/media';

const SContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const SWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 36px;
`;

const SSWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 716px;
    @media (max-width: ${media.tablet}) {
        max-width: none;
    }
`;

const SImageWrapper = styled.div`
    max-width: 516px;
    max-height: 340px;
    @media (max-width: ${media.tablet}) {
        display: none;
    }
`;

const SImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
`;

const SLink = styled.a`
    padding-left: 4px;
    color: inherit;
    font-weight: bold;
    text-decoration: none;
`;

export const ContactSection = () => {
    const { t } = useTranslation();

    const { file } = useStaticQuery(graphql`
        query contactImage {
            file(relativePath: { eq: "engineer.png" }) {
                publicURL
            }
        }
    `);
//                        <Form />
    return (
        <Section>
            <SContainer>
                <SWrapper>
                    <SSWrapper>
                        <Header text={t('contact.header')} />
                        <BodyText>
                            {t('contact.description')}
                            <SLink href="mailto:contact@turo.com.pl">contact@turo.com.pl</SLink>
                        </BodyText>
                    </SSWrapper>
                    <SImageWrapper>
                        <SImage src={file?.publicURL} alt="Digitalization support" />
                    </SImageWrapper>
                </SWrapper>
            </SContainer>
        </Section>
    );
};
